const HorizontalRule = () => {
  return <hr className="bg-current" />
}

export default HorizontalRule
